<span
  *ngIf="name != null && name !== ''"
  class="pointer"
  (click)="
    $event.stopPropagation();
    $event.preventDefault();
    app.profile.initProfile(id);
    "
  [title]="app.text.credits.open"
  >
 &nbsp;{{ app.users.getOptionName(name) }} &nbsp;
</span>
<span *ngIf="name === ''">
  {{ app.text.credits.unknown }}
</span>
